const { InspectorControls } = wp.editor
const { PanelBody, TextControl, ToggleControl } = wp.components;
import ImageControl from '../reusable/mediaUpload';

const Inspector = ({ attributes, setAttributes }) => {
  const { linkButton } = attributes

  return (
    <InspectorControls>
      <PanelBody>
        <ImageControl image='image' attributes={attributes} setAttributes={setAttributes} />
        <br />

        <TextControl
          label="Url do botão"
          value={ linkButton }
          onChange={linkButton => setAttributes({ linkButton })}
        />
      </PanelBody>
    </InspectorControls>
  )
}

export default Inspector
